// Define Error Prefix
const EMAIL_PREFIX = 1010;

// Define Error Codes
const MISSING_EMAIL = EMAIL_PREFIX + 1;
const BAD_EMAIL = EMAIL_PREFIX + 2;

// Public Error Codes
export const EMAIL_ERRORS = {
  MISSING_EMAIL,
  BAD_EMAIL,
};

// Corresponding Error Messages
export const EMAIL_ERROR_MESSAGES = {
  [MISSING_EMAIL]: "Email is required.",
  [BAD_EMAIL]: "Invalid Email.",
};

export default class EmailValidator {
  static validateEmail(email) {
    let errors = [];

    // Missing Email
    if (!email || !(email.length > 0)) {
      errors.push(MISSING_EMAIL);
      return {
        isValid: !errors.length,
        errors,
      };
    }

    // Valid Email By Regex (See Below)
    if (!EMAILREGEX.test(email)) {
      errors.push(BAD_EMAIL);
    }

    return {
      isValid: !errors.length,
      errors,
    };
  }

  static constructErrorMessage(errors) {
    const message = [];

    errors.forEach((error) => {
      message.push(EMAIL_ERROR_MESSAGES[error]);
    });

    return message.join(" ");
  }
}

const EMAILREGEX = /^([!#$%&*+-\/=?^`'|{}~\w_.]{1,64}?)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;



// WEBPACK FOOTER //
// ./client/app/services/validation/email.js